export default "__VITE_ASSET__f1621d4d__"